import { Injectable } from "@angular/core";
import { catchError, map } from "rxjs/operators";
import { environment } from "../../../../../../environments/environment";
import * as HSET from "../settings";
import { GenericHttpService } from "../../../../services/generic-http.service";
import { Observable } from "rxjs";
import { chart } from "highcharts";

@Injectable()
export class WarehouseSlaService {
  apiUrl = environment.gateWayHost;
  editItem: any;
  constructor(public generic: GenericHttpService) {}

  getWarehouseSLA(url, params): Observable<any> {
    const option = {
      method: "GET",
      // url: `${this.apiUrl}${this.apiUrlConstant.getOverallOtif}`,
      url: url, // "./assets/data/p-d-otif.json",
      query: params
    };
    return this.generic.httpRequest(option).pipe(
      catchError(this.generic.handleError),
      map(this.processWarehouseSLA.bind(this))
    );
  }

  processWarehouseSLA(data: any) {
    if (Object.keys(data.data).length === 0) return null;
    const underProcess = [],
      sla = [],
      quantity = [];

    const processedData = this.drillDownData(data.data[0].WarehouseSlaV2);

    const __v2Data = processedData["data"];
    const dataKeys = processedData["dataKeys"];
    const allData = processedData["dataObject"];
    const allKey = processedData["allKey"];

    const chart1 = {
      // underProcess: Number(
      //   (
      //     (100 * allData["in_process_quantity"]) /
      //     (allData["breached_quantity"] +
      //       allData["in_process_quantity"] +
      //       allData["non_breached_quantity"])
      //   ).toFixed(2)
      // ),
      sla: Number(
        (
          (100 * allData["non_breached_quantity"]) /
          (allData["breached_quantity"] +
            allData["non_breached_quantity"])
        ).toFixed(2)
      ),
      allKey: allKey
    };

    if (dataKeys.length) {
      dataKeys.map(_dataName => {
        const total =
          __v2Data[_dataName]["data"]["breached_quantity"] +
          __v2Data[_dataName]["data"]["non_breached_quantity"];

        underProcess.push(
          Number(
            (
              (100 * __v2Data[_dataName]["data"]["in_process_quantity"]) /
              total
            ).toFixed(2)
          )
        );

        sla.push(
          Number(
            (
              (100 * __v2Data[_dataName]["data"]["non_breached_quantity"]) /
              total
            ).toFixed(2)
          )
        );

        quantity.push(total + __v2Data[_dataName]["data"]["in_process_quantity"]);
      });
    }
    const chart2 = { underProcess, sla, quantity, dataKeys };
    return { chart1, chart2 };
  }

  createChart(chartData, Options) {
    const chart1 = JSON.parse(JSON.stringify(HSET.chart1));
    const chart2 = JSON.parse(JSON.stringify(HSET.chart2));

    //chart1.series[0].data = [chartData.chart1.underProcess];
    chart1.series[0].data = [chartData.chart1.sla];
    chart1.xAxis.categories = [chartData.chart1.allKey];

    //chart2.series[0].data = chartData.chart2.underProcess;
    chart2.series[0].data = chartData.chart2.sla;
    chart2.series[1].data = chartData.chart2.quantity;
    chart2.xAxis.categories = chartData.chart2["dataKeys"];

    return { chart1, chart2 };
  }

  drillDownData(data) {
    let dataKeys = [];
    let allKey = "All";
    let dataObject = { ...data["data"] };
    delete data["data"];

    if (Object.keys(data).length > 1) {
      dataKeys = Object.keys(data);
    } else if (Object.keys(data).length === 1) {
      allKey = Object.keys(data)[0];
      data = data[Object.keys(data)[0]];
      dataObject = { ...data["data"] };
      delete data["data"];
      if (Object.keys(data).length > 1) {
        dataKeys = Object.keys(data);
      } else if (Object.keys(data).length === 1) {
        allKey = Object.keys(data)[0];
        data = data[Object.keys(data)[0]];
        dataObject = { ...data["data"] };
        delete data["data"];
        dataKeys = Object.keys(data);
      }
    }
    return { data, dataKeys, dataObject, allKey };
  }
}
